<div class="fw-bold border-bottom mb-2">
    {{ header }}
</div>
<div class="overflow-auto">
    @for (item of eventAlarms; track $index) {
        <div class="align-middle px-0 text-nowrap d-flex">
            <div class="flex-grow-1 d-flex">
                <div class="me-2">
                    @switch (item.severity) {
                        @case ('CRITICAL') {
                            <i class="bi bi-exclamation-triangle-fill text-danger"></i>
                        }
                        @case ('WARNING') {
                            <i class="bi bi-exclamation-circle-fill text-warning"></i>
                        }
                        @case ('INFO') {
                            <i class="bi bi-info-circle-fill text-info"></i>
                        }
                    }
                </div>
                {{ 'event-alarms_' + item.eventType | translate }}
                @if (item.action != null) {
                    <div class="ms-2">
                        <i
                            class="bi bi-info-circle"
                            placement="right"
                            [autoClose]="'outside'"
                            popoverClass="custom-popover"
                            container="body"
                            [ngbPopover]="'event-alarms_' + item.action | translate"></i>
                    </div>
                }
            </div>
            <div>
                {{ item.created | appdatetime }}
            </div>
        </div>
    } @empty {
        <div class="py-1">
            <p class="text-center w-100 m-0">{{ 'utilities_NO_EVENTS' | translate }}</p>
        </div>
    }
</div>
